var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33661 2.66675C6.73661 2.66675 8.06994 3.20009 9.06994 4.20009C11.1366 6.26675 11.1366 9.66675 9.06994 11.7334C7.86994 13.0001 6.20327 13.4668 4.60327 13.2668L4.93661 11.9334C6.06994 12.0668 7.26994 11.6668 8.13661 10.8001C9.66994 9.26675 9.66994 6.73342 8.13661 5.13342C7.40327 4.40009 6.33661 4.00009 5.33661 4.00009V7.06675L2.00327 3.73342L5.33661 0.400085V2.66675ZM1.53661 11.7334C-0.196725 10.0001 -0.463392 7.33342 0.736608 5.26675L1.73661 6.26675C1.00327 7.73342 1.26994 9.60009 2.53661 10.8001C2.86994 11.1334 3.26994 11.4001 3.73661 11.6001L3.33661 12.9334C2.66994 12.6668 2.06994 12.2668 1.53661 11.7334Z",
    fill: "#F5B309"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume);
export default __webpack_public_path__ + "static/media/resume.edffd6f5bd7b0d032ba2c3705ae16869.svg";
export { ForwardRef as ReactComponent };